import React from 'react';
import currencyFormatter from 'common/currencyFormatter';

export const styles = {
    chargeEntry: {
        paddingTop: "10px",
        width: "400px",
        display: "inline-block"
    },
    chargeEntryName: {
        marginRight: "10px",
        textAlign: "right",
        width: "210px",
        display: "inline-block",
        fontWeight: 600
    },
    chargesSection: {
        marginLeft: "25px",
        pageBreakInsideAvoid: "avoid"
    },
    entryName: {
        marginRight: "10px",
        textAlign: "right",
        verticalAlign: "top",
        width: "36%",
        display: "inline-block",
        fontWeight: 600
    },
    entryChargeText: {
        display: "inline-block",
        marginLeft: "20px"
    },    
    invoiceThankYou: {
        fontSize: "larger",
        marginLeft: "auto",
        marginRight: "auto",
        width: "40%",
        fontWeight: 600,
        paddingTop: "60px",
        textAlign: "center"
    },        
    horizontalDivider: {
        marginLeft: "40px",
        marginRight: "40px",
        border: "1px solid black"
    },
    
    entryText: {
        maxWidth: "60%",
        display: "inline-block"
    },
    invoiceEntry: {
        width: "50%",
        display: "inline-block",
        fontSize: "1em",
    },
    invoiceEntryParent: {
        marginTop: "8px",
        display: "flex",
        justifyItems: "flex-start",
    },
    
    serviceNotesHeader: {
        paddingTop: "5px",
        paddingLeft: "45px",
        fontWeight: 600
    },
    serviceNotesSection: {
        minHeight: "115px"
    },
    serviceNotesText: {
        paddingTop: "10px",
        paddingLeft: "55px",
        paddingRight: "30px",
        paddingBottom: "10px",
        whiteSpace: "pre-wrap",
        fontSize: "0.9em",
    },
    invoiceHeader: {
        display: "block",
        marginLeft: "30px",
        fontSize: "18px",
        paddingTop: "20px"
    },
    invoiceHeaderImage: {
        marginLeft: "auto",
        marginRight: "auto",
        width: "20%",
        display: "block",
    },
    skylineInvoiceHeaderInfo: {
        marginLeft: "auto",
        marginRight: "auto",
        display: "flex",
    },
    summarySectionContainer : {  
      paddingBottom : "10px"
    },
    infoEntry: {
        width: "50%",
        display: "inline-block",
        fontSize: "1em"
    },
    infoEntryLineLeft: {
        marginLeft: "0.60em",
    },
    infoEntryLineRight: {
        textAlign: "right",
        marginRight: "2.1em"
    },
    invoiceType: {
        fontSize: "1.5rem",
        textTransform: "UPPERCASE",
        color: "lightgray",
        fontWeight: 600,
        paddingLeft: "0.65rem"
    },
    page: {
        background: "white",
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: "0.5cm",
        boxShadow: "0 0 0.5cm rgba(0,0,0,0.5)",
        width: "218mm",
        height: "279mm",
    }
}

const InvoiceEntry = (text,entry,entryTextStyle,id) => {
    if(text) {
        return (
            <div style={styles.invoiceEntry}>
                <div style={styles.entryName}>{text}:</div> 
                <div id={id || ''} style={entryTextStyle || styles.entryText}>{entry}</div>
            </div>
        )
    } else {
        return null;
    }
}

export function InvoiceRow(props) {
    const { leftText,leftEntry,rightText,rightEntry, styleRight, id } = props;
    return (
        <div style={styles.invoiceEntryParent} >
            {InvoiceEntry(leftText, leftEntry)}
            {InvoiceEntry(rightText, rightEntry, styleRight, id)}
        </div>
    )
}


export function HorizontalDivider() {
    return (
        <hr style={styles.horizontalDivider}/>
    )
}

export function ThankYouSection() {
    return(
        <div style={styles.invoiceThankYou}>Thank you for your business.</div>
    );
}

export function ServiceNotesSection(props) {
    const { serviceNotes } = props;
    return (
        <div style={styles.serviceNotesSection}>
            <div style={styles.serviceNotesHeader}>Service Notes</div>
            <div style={styles.serviceNotesText}>{serviceNotes}</div>
        </div>
    )
 }

 export function InvoiceChargeEntry({text,entry, entryStyle}) {        
    const entryId = text.split(' ').join('-').toLowerCase();
    return (            
        <div style={entryStyle} id={entryId}>
            <div style={styles.chargeEntryName}>{text}: </div><div style={styles.entryChargeText}>{currencyFormatter.formatUSD(entry)}</div>
        </div>
    )
}

export function SkylineHeader({isShopInvoice, imageSrc}) {
    return (
        <div>
            <div style={styles.invoiceHeader}>
                {isShopInvoice ? <div style={styles.invoiceType}>Shop Invoice</div>: <div/>}
                <img style={styles.invoiceHeaderImage} 
                     src={imageSrc} 
                     alt="Skyline Diesel and Towing Customer Management System" />
                <div style={styles.skylineInvoiceHeaderInfo}>
                    <div style={styles.infoEntry}>
                        <div style={styles.infoEntryLineLeft}>P.O. Box 46</div>
                        <div style={styles.infoEntryLineLeft}>Foristell, MO 63348</div>
                    </div>
                    <div style={styles.infoEntry}>
                        <div style={styles.infoEntryLineRight}>(636) 673-2211</div>
                    </div>
                </div>
            </div>                
        </div>
    );
}


export const PetroffHeader = (petroffImageSrc) => {
    return(
        <div style={styles.invoiceHeader}>
            <img style={styles.invoiceHeaderImage} 
                 src={petroffImageSrc} 
                 alt="Petroff Towing Customer Management System" />
            <div>
                <div style={styles.infoEntry}>
                    <div style={styles.infoEntryLineLeft}>3801 N. 89TH Steet</div>
                    <div style={styles.infoEntryLineLeft}>Caseyville, IL 62232</div>
                </div>
                <div style={styles.infoEntry}>
                    <div style={styles.infoEntryLineRight}>(618) 398-6000</div>
                    <div style={styles.infoEntryLineRight}>(800) 875-2561</div>
                </div>
            </div>
        </div>
    )
}